// export const BASE_URL = "http://localhost:8000";
export const BASE_URL =
  "https://expense-management-system-backend-s156.onrender.com";
